import { useEffect, useRef } from 'react';

// Hook de auto-refresh — chama a função a cada `intervalo` ms
// Para quando o componente desmonta
export function useAutoRefresh(fn, intervalo = 15000) {
  const fnRef = useRef(fn);
  fnRef.current = fn;

  useEffect(() => {
    const timer = setInterval(() => fnRef.current(), intervalo);
    return () => clearInterval(timer);
  }, [intervalo]);
}